<template>
  <div />
</template>
<script setup lang="ts">
definePage({
  redirect: '/accueil',
})
</script>
